<template>
  <div class="Create alignment">
    <loading :showLoading="load" />
    <h3 v-if="edit" class="styleHeader" style="margin-bottom: 31px">
      {{ $t("Categories.Edit") }}
    </h3>
    <h3 v-else class="styleHeader" style="margin-bottom: 31px">
      {{ $t("Categories.Add") }}
    </h3>
    <v-form ref="form" v-model="valid">
      <v-card class="styleDataTable border">
        <template>
          <v-container fluid>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="name"
                  :label="$t('Categories.Name')"
                  required
                  :rules="mandatoryRule"
                >
                </v-text-field> </v-col
            ></v-row>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="nameEn"
                  :label="$t('Categories.NameEn')"
                  required
                  :rules="mandatoryRule"
                >
                </v-text-field> </v-col
            ></v-row>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="description"
                  :label="$t('Categories.Description')"
                  required
                  :rules="mandatoryRule"
                ></v-text-field> </v-col
            ></v-row>
            <v-row dense>
              <v-col>
                <v-text-field
                  v-model="descriptionEn"
                  :label="$t('Categories.DescriptionEn')"
                  required
                  :rules="mandatoryRule"
                ></v-text-field> </v-col
            ></v-row>
            <v-row dense>
              <v-col>
                <v-checkbox
                  v-model="isRisk"
                  :label="$t('Categories.IsRisk')"
                ></v-checkbox> </v-col
            ></v-row>
            <v-row dense>
              <v-col>
                <v-autocomplete
                  v-model="selectedStates"
                  :items="states"
                  item-value="LetterCode3"
                  item-text="CommonName"
                  dense
                  chips
                  small-chips
                  :label="$t('Categories.CountryPenalty')"
                  multiple
                ></v-autocomplete> </v-col
            ></v-row>
            <v-row dense>
              <v-col>
                <v-checkbox
                  v-model="enabled"
                  :label="$t('Categories.Enabled')"
                ></v-checkbox> </v-col
            ></v-row>
          </v-container>
        </template>
      </v-card>
      <v-btn
        class="white--text styleButtonTop styleAlignementSaveButton border"
        @click="save()"
        color="black"
      >
        <v-icon left>fas fa-check-circle</v-icon>
        {{ $t("SearchMenu.Button.Save") }}
      </v-btn>
      <v-btn class="styleButtonTop border" @click="back()">
        <v-icon left>fas fa-times-circle</v-icon>
        {{ $t("SearchMenu.Button.Cancel") }}
      </v-btn>
    </v-form>

    <v-snackbar v-model="showErr" color="error">
      {{ textErr }}
      <v-btn color="white" text @click="showErr = false">
        {{ $t("Misc.Close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import loading from "../../components/loadingComponent.vue";
import { Trans } from "@/plugins/Translation";
import BackEndApi from "../../api/AllRisk/allRiskApi.js";
import IMApi from "../../api/IM/IMApi.js";
import router from "@/router/index.js";
import allRiskApi from "../../api/AllRisk/allRiskApi.js";

export default {
  components: { loading },

  data() {
    return {
      load: false,
      showErr: false,
      textErr: "",
      valid: false,
      edit: false,

      // model
      name: "",
      nameEn: "",
      description: "",
      descriptionEn: "",
      isRisk: false,
      countryPenalty: "",
      states: [],
      selectedStates: [],
      enabled: false,

      mandatoryRule: [(v) => !!v || Trans.i18n.t("Validations.Mandatory")],
    };
  },

  async created() {
    // only ad user can be access
    let aduserInfo_res = await IMApi.GetADUserInformationByUsername(
      this.$GAUserAuth.user.username
    );
    if (!aduserInfo_res.data) {
      this.$router.push({ name: "unauthorized" });
    }

    // only admins can create/edit categories
    if (!this.$GAUserAuth.isAdmin()) {
      //   console.log("base user");
      this.$router.push({ name: "unauthorized" });
    }

    const id = this.$route.params.Id;
    IMApi.GetStates().then((response) => {
      this.states = response.sort(function (a, b) {
        if (a.CommonName < b.CommonName) {
          return -1;
        }
        if (a.CommonName > b.CommonName) {
          return 1;
        }
        return 0;
      });
    });

    if (id) {
      this.edit = true;
      BackEndApi.GetCategory(id)
        .then((response) => {
          this.name = response.data.name;
          this.nameEn = response.data.nameEn;
          this.description = response.data.description;
          this.descriptionEn = response.data.descriptionEn;
          this.isRisk = response.data.isRisk;
          this.enabled = response.data.enable;
          this.countryPenalty = response.data.countryPenalty;
          this.selectedStates = response.data.countryPenalty
            .split(";")
            .filter((item) => item);
        })
        .catch((e) => {
          this.showErr = true;
          this.textErr = e.response.data;
        });
    }
  },
  methods: {
    back() {
      router.push({ name: "CategoriesIndex" });
    },

    save() {
      var isValid = this.$refs.form.validate();

      if (isValid) {
        var category = {
          Id: this.$route.params.Id,
          Name: this.name,
          NameEn: this.nameEn,
          Description: this.description,
          DescriptionEn: this.descriptionEn,
          IsRisk: this.isRisk,
          CountryPenalty: this.selectedStates.join(";"),
          Enable: this.enabled,
        };
        // console.log("category", category, this.selectedStates);

        allRiskApi
          .AddCategory(category)
          .then((response) => {
            // console.log("addcategory result", response.data);
            router.push({ name: "CategoriesIndex" });
          })
          .catch((e) => {
            // console.log("addcategory result", e.response);
            this.showErr = true;
            this.textErr = e.response.data.Message;
          });
      }
    },
  },
};
</script>

<style>
</style>